import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b43dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center"} }, " Face Check "),
  /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center","margin":"5px 0 0 10px","font-size":"8px"} })
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Load Face ")
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Face select ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"flex":"1"} }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_button, {
          disabled: _ctx.disabled,
          onClick: _ctx.loadFace
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facesArray, (face) => {
        return (_openBlock(), _createBlock(_component_a_card, {
          key: face.id,
          class: "card disable-draggable",
          size: "small",
          onClick: () => _ctx.setClick(face)
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              style: {"width":"100%","max-width":"120px","height":"100%","margin-right":"10px","object-fit":"cover","border-radius":"10px"},
              src: face.mediaUrl
            }, null, 8, _hoisted_4),
            _createVNode(_component_a_checkbox, {
              style: {"margin-top":"10px"},
              checked: _ctx.getSelectedImage(face),
              onClick: _withModifiers(() => _ctx.setClick(face), ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["checked", "onClick"])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}